import { tidalAxios } from '@tidal/axios';
export const TIDAL_TRACKING_STAGE_ENDPOINT = 'https://et.stage-v2.tidalhi.fi/api/public/events';
export const TIDAL_TRACKING_PROD_ENDPOINT = 'https://et.tidal.com/api/public/events';
export const TIDAL_TOKEN = 'WEB';
export const TIDAL_TRACKING_COOKIE_NAME = 'tdlTrkv2';
const TIDAL_TRACKING_COOKIE_DEFAULT_OPTIONS = {
    maxAge: 30 * 24 * 60 * 60,
    path: '/',
    sameSite: 'lax',
};
export function getTidalTrackingCookieOptions(moduleCookieOptions) {
    return {
        ...TIDAL_TRACKING_COOKIE_DEFAULT_OPTIONS,
        domain: moduleCookieOptions.domain,
        secure: moduleCookieOptions.secure,
    };
}
export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
export function captureUtms(data, query) {
    let captured = false;
    const utms = {};
    for (const utmKey of UTM_KEYS) {
        const utmValue = query.get(utmKey);
        if (utmValue && typeof utmValue === 'string') {
            captured = true;
            utms[utmKey] = utmValue;
        }
    }
    if (captured) {
        data.utms = utms;
        data.utmsCapturedTime = Date.now();
    }
    return captured;
}
export class TidalTrackingInterface {
    constructor(config) {
        const tidalAxiosConfig = {
            enableRequestLogging: false,
            shouldLogError: (axiosError) => {
                return !!axiosError.response && axiosError.response.status >= 500;
            },
            shouldRetry: (axiosError) => {
                return !!axiosError.response && [503, 504].includes(axiosError.response.status);
            },
        };
        this.axios = tidalAxios('tracking', typeof window === 'undefined' ? tidalAxiosConfig : undefined);
        if (config.useProxy) {
            this.endpoint = `${config.baseUrl}/et/`;
        }
        else {
            this.endpoint = config.useProductionEndpoint ? TIDAL_TRACKING_PROD_ENDPOINT : TIDAL_TRACKING_STAGE_ENDPOINT;
        }
        this.oauthClientId = config.oauthClientId || '';
        this.serviceVersion = config.serviceVersion || '';
    }
    async sendCDFEvent(event) {
        try {
            await this.axios.post(this.endpoint, {
                batchId: '',
                events: [event],
            }, {
                headers: {
                    'x-tidal-token': TIDAL_TOKEN,
                },
            });
        }
        catch (error) {
            console.error(`Failed sending CDF TIDAL event "${event.name}". Error: "${error.message}".`);
        }
    }
}
